import { Box, Grid, Typography, useScrollTrigger } from "@mui/material";
import React, { useEffect, useState } from "react";
import { farmers, taskAssign } from "../../config/images";
import "../DataCollector/DataCollector.css";
import { useNavigate, useParams } from "react-router-dom";
import { deactivateDataCollectorList, getDataCollectorListDetails } from "../../config/services";
import Shimmer from "../../components/Shimmer/Shimmer";

const DataCollectorDetail = () => {
  const navigate = useNavigate();

  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [collectorDetails, setCollectorDetails] = useState({
    profileImage: farmers.farmerDetailsImage,
    FirstName: "",
    MiddleName: "",
    LastName: "",
    Gender: "",
    MobileNumber: "",
    Email: "",
    isActive: false,
  });
  const fetchData = async () => {
    try {
      setLoading(true);
      const resp = await getDataCollectorListDetails(params.id);
      if (resp.data) {
        setCollectorDetails({
          profileImage: resp.data.profile_photo || farmers.farmerDetailsImage,
          FirstName: resp.data.first_name || "",
          MiddleName: resp.data.middle_name || "",
          LastName: resp.data.last_name || "",
          Gender: resp.data.gender == 0 ? "Male" : "Female",
          MobileNumber: resp.data.mobile_number || "",
          Email: resp.data.email || "",
          isActive: resp.data.is_active,
        })
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.log("error", error)
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const handleDeactive = async () => {
    try {
      const id = params.id;

      const data = {
        is_active: !collectorDetails.isActive
      }
      const resp = await deactivateDataCollectorList(id, data);
      if (resp.data.success == true) {
        fetchData();
      }


    } catch (error) {
      console.log("error", error)
    }
  }


  return (
    <>
      <Box className="task-detail-box">
        <Box className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap" }}>
          <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
            <img
              src={taskAssign.backArrow}
              alt=""
              style={{ height: "44px", width: "44px", cursor: "pointer" }}
              onClick={() => navigate("/collectors-list")}
            />
            <img
              src={taskAssign.collector}
              alt=""
              style={{ height: "44px", width: "44px" }}
            />
            <Typography variant="h6" gutterBottom>
              Data Collectors
            </Typography>
          </Box>
          <Box className="d-flex align-items-center assign-data-btn">
            <button
              className="deactivate-btn"
              style={{ height: "46px", marginRight: "20px" }}
              onClick={handleDeactive}
            >
              {collectorDetails.isActive == true ? "Deactivate" : "Activate"}
            </button>
          </Box>
        </Box>
        <Box>
          <div className="user-profile">
            <Grid container spacing={2}>
              <Grid item lg={8}>
                {["FirstName", "MiddleName", "LastName", "Gender", "MobileNumber", "Email", "isActive"].map((field, index) => (
                  <Grid container key={index}
                    style={index === 0 ? { borderTop: "1px solid #D9D9D9" } : {}}>
                    <Grid item xs={12} sm={4} md={4} lg={4} className="grid-item" style={{ paddingLeft: "20px" }}>
                      {field === "isActive" ? "Status" :
                        field.replace(/([A-Z])/g, " $1").trim()
                      }
                    </Grid>
                    {field === "isActive" ?
                      <Grid item xs={12} sm={8} md={8} lg={8}
                        style={{ fontWeight: 700, color: collectorDetails.isActive == true ? "#31A05F" : "#3C4856" }}
                        className="grid-item"
                      >
                        {loading ? <Shimmer style={{ height: "20px", width: "100%" }} />
                          : collectorDetails.isActive == true ? "Active" : "In active"

                        }
                      </Grid>
                      :
                      <Grid item xs={12} sm={8} md={8} lg={8}
                        style={{ fontWeight: 700, color: "#3C4856" }}
                        className="grid-item"
                      >
                        {loading ? <Shimmer style={{ height: "20px", width: "100%" }} />
                          : collectorDetails[field]
                        }
                      </Grid>
                    }

                  </Grid>
                ))}
              </Grid>


              <Grid item lg={4}>
                {collectorDetails.profile_photo ? (
                  <img
                    src={collectorDetails.profile_photo}
                    alt="Farmer"
                    className="user-image"
                    style={{ height: "316px", width: "100%" }}
                  />) :
                  <div style={{ background: "#f0f0f0", height: "316px", width: "100%", textAlign: "center", paddingTop: "25%" }}> No Image</div>
                }

              </Grid>
            </Grid>
          </div>
        </Box>
      </Box>
    </>
  );
};

export default DataCollectorDetail;
